import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialog: {
    margin: "0 auto",
    [theme.breakpoints.up("lg")]: {
      width: "100%"
    },
    "& $dialogContent": {
      padding: "inherit"
    }
  },
  dialogPaper: {
    maxWidth: "100%",
    maxHeight: "100%",
    margin: "0px",
    [theme.breakpoints.up("md")]: {
      maxWidth: "840px"
    },
    [theme.breakpoints.up("lg")]: {
      position: "fixed"
    }
  },
  dialogContent: {
    padding: "0"
  },
  openButton: {
    display: "flex",
    color: theme.palette.secondary.dark,
    textTransform: "initial",
    fontSize: "16px"
  },
  openButtonIcon: {
    marginLeft: "2px",
    transition: "all .2s",
    verticalAlign: "middle"
  },
  openButtonIconOpened: {
    transform: "rotate(180deg)"
  }
}));
